module.exports = __webpack_public_path__ + "media/images/partner-alt-5-d5d213751e549cce54861f567fedd5ed.png";